import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { JuresService } from 'src/app/data/commission/services/jures/jures.service';
import { Jure } from 'src/app/data/commission/models/jure.model';
import { map, catchError } from 'rxjs/operators';
import { AbstractRechercheItemComponent } from '../abstract-recherche-items.component';
import { LoaderService } from 'src/app/core/services/loader/loader.service';

@Component({
    selector: 'app-recherche-jure',
    templateUrl: './recherche-jure.component.html',
    styleUrls: ['./recherche-jure.component.scss'],
    standalone: false
})
export class RechercheJureComponent extends AbstractRechercheItemComponent<Jure> implements OnInit {
    @Input() idOrganisme: number;
    @Input() idsCdcs: number[];
    @Input() alreadySelectedJuresIds: number[];

    jures: Jure[] = [];

    constructor(public readonly modal: NgbActiveModal, private readonly juresService: JuresService, private readonly loaderService: LoaderService) {
        super(modal);
    }

    getData() {
        return this.juresService.getJuresByCdcs(this.idOrganisme, this.idsCdcs).pipe(
            this.loaderService.operator(),
            map(juresCdc => {
                // Exclude already selected
                const filtered = juresCdc.filter(j => this.alreadySelectedJuresIds.indexOf(j.id) === -1);
                // Map JureCdc -> Jure (minimal fields required by Jure)
                return filtered.map((jc: any) => ({
                    id: jc.id,
                    nom: jc.nom,
                    college: jc.colleges && jc.colleges.length ? jc.colleges[0] : undefined,
                    cahier: jc.cahiers && jc.cahiers.length ? jc.cahiers[0] : undefined,
                    libelleCahier: jc.cahiers && jc.cahiers.length && jc.cahiers[0].libelle ? jc.cahiers[0].libelle : '',
                    idsOperateurs: jc.idsOperateurs || [],
                    dateDerniereFormation: jc.dateDerniereFormation,
                    mail: jc.mail,
                    operateurs: jc.operateurs
                }));
            }),
            catchError(error => {
                this.modal.dismiss(error);
                throw error;
            })
        );
    }
}
